import { QueryReturnValue } from '@reduxjs/toolkit/dist/query/baseQueryTypes'
import { FetchBaseQueryError, FetchBaseQueryMeta } from '@reduxjs/toolkit/query'
import { apiPath } from 'config'
import { OrderByDate } from 'types'
import { GetPoolsPaginationResponse, GetPoolsTransformResponse } from 'types/pools'

export const fetchPools = async (arg, _api, _extraOptions, baseQuery) => {
  const limit = arg?.limit !== undefined ? `&limit=${arg.limit}` : ''
  const page = arg?.page !== undefined ? `&page=${arg.page}` : ''
  const orderByDate = `&orderByDate=${arg?.orderByDate ? arg.orderByDate : OrderByDate.DESC}`
  const status = arg?.status !== undefined ? `&${arg.status.map((s) => `status=${s}`).join('&')}` : ''
  const type = arg?.type !== undefined ? `&type=${arg.type}` : ''
  const url = `${apiPath.pool}?fundAddress=${arg.fundAddress}${limit + page + orderByDate + status + type}`

  const result: QueryReturnValue<unknown, FetchBaseQueryError, FetchBaseQueryMeta> = await baseQuery({
    method: 'GET',
    url,
  })

  if (!result.data) {
    return { error: result.error as FetchBaseQueryError }
  }

  const { data: pools } = result.data as GetPoolsPaginationResponse

  const transformPools = pools.map((pool) => {
    if (!pool.logo) {
      return pool
    }
    const objLogo = JSON.parse(pool.logo)
    return { ...pool, logo: objLogo }
  })

  return {
    data: { ...(result.data as GetPoolsPaginationResponse), data: transformPools } as GetPoolsTransformResponse,
  }
}
